export const read = <T>(
  type: 'localStorage' | 'sessionStorage',
  key: string,
  defaultValue?: T
) => {
  if (typeof window !== 'undefined') {
    try {
      const item = window[type].getItem(key);
      return item ? (JSON.parse(item) as T) : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  }
};

export const write = <T>(
  type: 'localStorage' | 'sessionStorage',
  key: string,
  value: T
) => {
  if (typeof window !== 'undefined') {
    window[type].setItem(key, JSON.stringify(value));
  }
};
